// #region Constants

export const DESKTOP = 'desktop';
export const TABLET_LANDSCAPE = 'tablet-landscape';
export const TABLET_PORTRAIT = 'tablet-portrait';
export const MOBILE = 'mobile';

const sizes = [DESKTOP, TABLET_LANDSCAPE, TABLET_PORTRAIT, MOBILE];

// #endregion Constants

// #region Exports

export function smallerThan(size:string) {
    const current = getCurrentState();
    return sizes.indexOf(size) < sizes.indexOf(current);
};

export function largerThan(size:string) {
    const current = getCurrentState();
    return sizes.indexOf(size) >= sizes.indexOf(current);
};

export function isMobile() {
    return navigator.userAgent.match(/BlackBerry|Tablet|iPhone|iPod|Opera Mini|Android|IEMobile/i);
};

// #endregion Exports

// #region Private

function getCurrentState() {
    return window.getComputedStyle(document.querySelector('body'), ':after').getPropertyValue('content').replace(/\"/g, '');
}

// #endregion Private
